import { observer } from 'mobx-react-lite'
import React, { Fragment, useState } from 'react'
import { Pen } from 'react-bootstrap-icons'
import RatingModal from './RatingModal'

export default observer(function RatingButton({ hasOwnRating }) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <Fragment>
      <button
        className="flex items-center gap-2 bg-rb-green text-white text-sm font-semibold px-4 py-2 rounded-lg dark:text-rb-dark-mode"
        onClick={() => setIsModalOpen(true)}
      >
        <Pen /> {hasOwnRating ? 'Edit your review' : 'Write a review'}
      </button>
      {isModalOpen && <RatingModal setIsOpen={setIsModalOpen} isOpen={isModalOpen} />}
    </Fragment>
  )
})
